export default "__VITE_ASSET__rFaYST4Q__"